var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tbl-skeleton"},_vm._l((_vm.rows),function(r){return _c('div',{key:r,staticClass:"tbl-skeleton__row"},_vm._l((_vm.cols),function(c){return _c('div',{key:c,staticClass:"tbl-skeleton__cell"},[_c('div',{staticClass:"tbl-skeleton__bar",style:({ width: _vm.barWidth(c) })})])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }